import React, { Component } from "react";
import "./ResendEmail.css";
import MMCL_Logo from "../static/images/MMCL_Logo.webp";
import { toast } from "react-toastify";
import axios from "../api/axios.js";
import hideElements from '../utility/Tools.js';
import ValidateEmail from "./custom_validations/ValidateEmailCheck.js";
function resendEmail(){
  if(document.getElementById('validEmailText').style.color==='green'){
    var ResendEmail_url="resendver/"+document.getElementById('inputEmail').value;
    axios.get(ResendEmail_url)
    hideElements();
    toast.success('Email has been successfully sent.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    });
    //Put timer for redirection of page
    setTimeout(function () {
      window.location.href = '/sign-in';
  }, 5000);
  }
}


export class ResendEmail extends Component {
  static displayName = ResendEmail.name;

  componentDidMount(){
    document.getElementById("inputEmail").addEventListener("keypress", function(event){
      if(event.key==="Enter"){
        event.preventDefault();
        document.getElementById("btnSendEmail").click();
      }
  })
}

  render() {
    return (
      <div className="resend-email">
            <div className="card resend-email-card">
          <form>
            <div className="resend-email-logo-container text-center">
              <img src={MMCL_Logo} className="resend-email-logo" alt="MMCL Logo" />
            </div>
            <h3 id="resendEmailHeader" className="text-center mt-10 b-10">Enter your registered email address.</h3>
            <p id="resendEmailText" class="text-center mt-5 mb-5">An email will be sent to your email address to allow you to activate your account.</p>
            <div className="form-outline mb-4 hiding-elements">
              <label className="form-label" for="inputEmail">
                Email address
              </label>
              <input type="email" id="inputEmail" className="form-control" onChange={ValidateEmail}/>
            </div>
            <div id="emailRequirements" style={{ display: "none" }} className="resend-email-email-requirement hiding-elements">
              <li id="validEmailText">✕ Must be a valid email!</li>
              <br/>
            </div>
            <div className="text-center hiding-elements">
              <button
                id="btnSendEmail"
                type="button"
                className="btn btn-block mb-4 sign-in-button"
                onClick={() => resendEmail()}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
